// Colonnes, options et valeurs vides des tableaux du matériel médical.

export const emptyRow = {
    cltPharmacie: false,
    patient: "",
    patientNom: "",
    patientPrenom: "",
    notInvoiced: false,
    inactive: false,
    equipmentType: "",
    creditAuthorization: "",
    deposit: "",
    depositAmount: "",
    rentalContract: "",
    amo: "",
    amc: "",
    clientContact: "",
    rentalStartDate: "",
    rentalEndDate: "",
    prescriptionDate: "",
    prescriptionEndDate: "",
    matricule: "",
    equipmentRegistrationNumber: "",
    credit: "",
    remarks: "",
    postalSendDate: "",
    postalSendDetails: "",
    billingUpToDate: "",
    equipmentReturned: false,
    date: "",
    administrativeTask: "",
    billingRemark: "",
};

export const CREDIT_AUTHORIZATION_OPTIONS = ["", "Oui", "Non", "DCD"];
export const YES_NO_DCD_OPTIONS = ["", "Oui", "Non", "DCD"];
export const DEPOSIT_OPTIONS = ["", "Oui", "Non", "DCD", "Refus", "Montant"];
export const CONTACT_OPTIONS = ["", "Numero/Email", "Complet", "Aucune"];
export const DCD_OPTIONS = ["", "Non", "DCD"];
export const EQUIPMENT_TYPE_OPTIONS = [
    "",
    "Lit médicalisé",
    "Tire-lait",
    "Fauteuil roulant",
    "Matelas à air",
    "Potence de lit",
    "Aérosol nébulisateur",
];

export const MEDICAL_EQUIPMENT_MEDICAMENT_STRATEGY = {
    showDestination: false,
    showDosage: false,
    showSiBesoin: false,
    showClassificationMedicament: false,
    defaultDestination: "ETIQUETAGE",
    ROBOT: { showRobotFields: false, showEtiquetageFields: false },
    ETIQUETAGE: { showRobotFields: false, showEtiquetageFields: false },
};

export const COLUMNS = [
    { key: "cltPharmacie", label: "CLT PHARMACIE", type: "checkbox", width: 120 },
    { key: "patient", label: "PATIENT", width: 190 },
    { key: "equipmentType", label: "TYPE DE MATERIEL", type: "select", options: EQUIPMENT_TYPE_OPTIONS, width: 180 },
    { key: "creditAuthorization", label: "AUTORISATION CREDIT", type: "select", options: CREDIT_AUTHORIZATION_OPTIONS, width: 170 },
    { key: "deposit", label: "CAUTION CB OU CHEQUE 1000€", type: "deposit", options: DEPOSIT_OPTIONS, width: 210 },
    { key: "rentalContract", label: "CONTRAT DE LOC", type: "select", options: YES_NO_DCD_OPTIONS, width: 150 },
    { key: "amo", label: "A.M.O", type: "select", options: YES_NO_DCD_OPTIONS, width: 110 },
    { key: "amc", label: "AMC", type: "select", options: YES_NO_DCD_OPTIONS, width: 110 },
    { key: "clientContact", label: "CONTACT CLT", type: "select", options: CONTACT_OPTIONS, width: 150 },
    { key: "rentalStartDate", label: "DEBUT DE LOCATION", type: "date", width: 155 },
    { key: "rentalEndDate", label: "FIN DE LOCATION", type: "date", width: 145 },
    { key: "prescriptionDate", endKey: "prescriptionEndDate", label: "DATE ORDO", type: "dateRange", width: 220 },
    { key: "matricule", label: "MATRICULE", width: 140 },
    { key: "equipmentRegistrationNumber", label: "MATERIELL PHARMACIE : NUMERO DE MATRICULE INTERNE / MATERIEL PRESTATAIRE (ALCURA / ORKYN) : NUMERO DE MATRICULE", width: 310 },
    { key: "credit", label: "CREDIT", width: 140 },
    { key: "remarks", label: "REMARQUES", width: 220 },
    { key: "postalSendDetails", dateKey: "postalSendDate", label: "DATE ENVOIE POSTE", type: "textDate", width: 230 },
    { key: "billingUpToDate", label: "FACTURATION A JOUR / MONTANT A FACTURER", type: "select", options: YES_NO_DCD_OPTIONS, width: 260 },
    { key: "equipmentReturned", label: "MATERIEL RENDU", type: "checkbox", width: 150 },
    { key: "date", label: "Date", type: "date", width: 120 },
    { key: "administrativeTask", label: "Tache administratif", width: 210 },
    { key: "billingRemark", label: "REMARQUE FACTURATION", width: 220 },
];

export const FOLLOW_UP_GROUPS = [
    {
        key: "patient",
        label: "Patient",
        header: "#475569",
        subHeader: "#e2e8f0",
        cell: "#f8fafc",
        border: "#cbd5e1",
        columns: ["cltPharmacie", "patient", "equipmentType"],
    },
    {
        key: "rental",
        label: "Location et dossier",
        header: "#be185d",
        subHeader: "#fce7f3",
        cell: "#fdf2f8",
        border: "#fbcfe8",
        columns: ["creditAuthorization", "deposit", "rentalContract", "amo", "amc", "clientContact", "rentalStartDate", "rentalEndDate", "prescriptionDate", "matricule", "equipmentRegistrationNumber", "credit", "remarks"],
    },
    {
        key: "postal",
        label: "Envoi postal",
        header: "#15803d",
        subHeader: "#dcfce7",
        cell: "#f0fdf4",
        border: "#bbf7d0",
        columns: ["postalSendDetails"],
    },
    {
        key: "billing",
        label: "Facturation et retour",
        header: "#a16207",
        subHeader: "#fef3c7",
        cell: "#fffbeb",
        border: "#fde68a",
        columns: ["billingUpToDate", "equipmentReturned"],
    },
    {
        key: "administrative",
        label: "Suivi administratif",
        header: "#1d4ed8",
        subHeader: "#dbeafe",
        cell: "#eff6ff",
        border: "#bfdbfe",
        columns: ["date", "administrativeTask", "billingRemark"],
    },
];

export const COLUMN_BY_KEY = Object.fromEntries(COLUMNS.map(column => [column.key, column]));
export const FOLLOW_UP_GROUP_BY_COLUMN = Object.fromEntries(
    FOLLOW_UP_GROUPS.flatMap(group => group.columns.map(columnKey => [columnKey, group]))
);
export const COLUMN_COLOR_SWATCHES = ["#FCE7F3", "#FEE2E2", "#FEF3C7", "#DCFCE7", "#DBEAFE", "#EDE9FE", "#E2E8F0"];
export const FOLLOW_UP_MERGE_FIELDS = [
    "cltPharmacie", "patientNom", "patientPrenom", "notInvoiced", "inactive", "equipmentType",
    "creditAuthorization", "deposit", "depositAmount", "rentalContract", "amo", "amc",
    "clientContact", "rentalStartDate", "rentalEndDate", "prescriptionDate",
    "prescriptionEndDate", "matricule", "equipmentRegistrationNumber", "credit", "remarks",
    "postalSendDate", "postalSendDetails", "billingUpToDate", "equipmentReturned", "date",
    "administrativeTask", "billingRemark",
];
export const FOLLOW_UP_FIELD_LABELS = {
    patientNom: "Nom",
    patientPrenom: "Prénom",
    notInvoiced: "Pas facturé",
    inactive: "Patient inactif",
    ...Object.fromEntries(COLUMNS.map(column => [column.key, column.label])),
};

export const PATIENT_CONTACT_COLUMNS = [
    { key: "patient", label: "PATIENT", width: 200 },
    { key: "dcd", label: "DCD", type: "select", options: DCD_OPTIONS, width: 110 },
    { key: "rentalEquipment", label: "MATERIEL DE LOCATION", width: 230 },
    { key: "phoneNumbers", label: "NUMERO DE TELEPHONE", type: "phones", width: 230 },
    { key: "credit", label: "CREDIT", width: 160 },
    { key: "remark", label: "REMARQUE", width: 300 },
    { key: "sentDate", label: "DATE D'ENVOI", type: "date", width: 150 },
];

export const emptyPatientContact = {
    followUpId: null,
    patient: "",
    nom: "",
    prenom: "",
    notInvoiced: false,
    inactive: false,
    dcd: "",
    rentalEquipment: "",
    phoneNumbers: [],
    credit: "",
    remark: "",
    sentDate: "",
};

export const emptySupplier = {
    name: "",
    email: "",
    emails: [],
    phone: "",
    address: "",
    contactName: "",
    notes: "",
};

export const PARK_STATUS_OPTIONS = [
    { value: "AVAILABLE", label: "Disponible" },
    { value: "RENTED", label: "En location" },
    { value: "MAINTENANCE", label: "En attente d'entretien" },
];

export const emptyParkItem = {
    internalNumber: "",
    matriculeName: "",
    purchaseDate: "",
    status: "AVAILABLE",
    currentTenant: "",
    currentTenantEmail: "",
    currentTenantPhone: "",
    currentRentalStartDate: "",
    rentalDurationDays: "",
    currentRentalEndDate: "",
    installationRequired: false,
    maintenanceRequired: false,
    maintenanceProcedureId: "",
    notes: "",
};

export const emptyMaintenanceProcedure = {
    name: "",
    description: "",
};
